import {
  /** FETCH GETBASKET  */
  FETCH_GETBASKET_FULFILLED,
  FETCH_GETBASKET_REJECTED,
  FETCH_GETBASKET_PENDING,
  RESET_GETBASKET,
} from "../../actions/payment/getBasket";
const initialState = {
  done: false,
  error: false,
  spinner: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GETBASKET_PENDING:
      return {
        done: false,
        error: false,
        spinner: true,
      };
    case FETCH_GETBASKET_FULFILLED:
      return {
        ...state,
        getBasket: action.payload,
        done: true,
        error: false,
        spinner: false,
      };
    case FETCH_GETBASKET_REJECTED:
      return {
        ...state,
        error: action.payload,
        done: false,
        spinner: false,
      };
    case RESET_GETBASKET:
      return {
        initialState,
        done: false,
        error: false,
        spinner: false,
      };
    default:
      return state;
  }
};
